module.exports = __webpack_public_path__ + "img/gift_1.3cb96f11.png";